import { FormulaModel } from './FormulaModel';
import { Instance, types } from 'mobx-state-tree';
import { SurveyType } from './surveyType.enum';

export const Survey = types.model('SurveyModel', {
  _id: types.identifier,
  title: types.maybeNull(types.string),
  displayInfo: types.maybeNull(types.boolean),
  shortDescription: types.maybeNull(types.string),
  humanReadableId: types.maybeNull(types.string),
  image: types.maybeNull(types.string),
  longDescription: types.maybeNull(types.string),
  estimatedTime: types.maybeNull(types.string),
  type: types.maybeNull(types.enumeration(Object.values(SurveyType))),
  language: types.maybeNull(types.string),
  formulas: types.maybeNull(types.array(FormulaModel)),
  isTree: types.maybeNull(types.boolean),
  withQuestions: types.boolean,
  designSystemColor:types.maybeNull(types.string),
});


export interface ISurvey extends Instance<typeof Survey> {}
